
define('text!modules/campaign/templates/chart_change_log_ttip.html',[],function () { return '<label>\n  <strand-scroll-panel class="chart-multi-marker-tooltip-list">\n    {{#dates}}\n    <div class="list-item multi-marker-btn">{{date}}</div>\n    {{/dates}}\n  </strand-scroll-panel>\n</label>\n';});

